import { render } from "./right2pie.vue?vue&type=template&id=14785e21"
import script from "./right2pie.vue?vue&type=script&lang=js"
export * from "./right2pie.vue?vue&type=script&lang=js"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__